import React from "react";
import { Button } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";

const SmartStatusButton = ({ status, onPause, onResume }) => {
  const handleClick = () => {
    if (status === "processing" && onPause) onPause();
    else if (status === "paused" && onResume) onResume();
  };

  const getButtonConfig = () => {
    switch (status) {
      case "processing":
        return { label: "Pause", icon: <PauseIcon />, color: "warning" };
      case "paused":
        return { label: "Resume", icon: <PlayArrowIcon />, color: "primary" };
      case "completed":
        return {
          label: "Completed",
          icon: <CheckCircleIcon />,
          color: "success",
          disabled: true,
        };
      case "scheduled":
        return {
          label: "Scheduled",
          icon: <ScheduleIcon />,
          color: "info",
          disabled: true,
        };
      default:
        return {
          label: "Unknown",
          icon: null,
          color: "inherit",
          disabled: true,
        };
    }
  };

  const { label, icon, color, disabled } = getButtonConfig();

  return (
    <Button
      variant="contained"
      color={color}
      startIcon={icon}
      onClick={handleClick}
      disabled={disabled}
      sx={{
        textTransform: "none",
        borderRadius: 2,
        px: 2.5,
      }}
    >
      {label}
    </Button>
  );
};

export default SmartStatusButton;
